import styles from './ExamChangeTable.module.scss'
import React, { ReactElement, useMemo } from 'react'
import { ExamChangeTableProps } from '@/components/ExamChangeGuidePage/ExamChangeVisualization/ExamChangeTable/ExamChangeTable.types'
import {
    PostSpring2023ExamCode,
    PreSpring2023ExamCode,
} from '@/components/ExamChangeGuidePage/ExamChangeGuidePage.types'
import { hashExamChangeAnalysisKey } from '@/components/ExamChangeGuidePage/utils'
import { CHAPTER_COUNT_BY_KEY_MAP } from '@/components/ExamChangeGuidePage/consts'
import Table from 'antd/lib/table'

export const ExamChangeTable: React.FC<ExamChangeTableProps> = (
    props
): ReactElement => {
    const columns = useMemo((): {
        title: string
        dataIndex: string
        key: string
    }[] => {
        return [
            {
                title: '',
                dataIndex: 'previousExamCode',
                key: 'previousExamCode',
            },
            ...Object.entries(PostSpring2023ExamCode).map(
                ([examKey, examDisplay]) => ({
                    title: examDisplay,
                    dataIndex: examKey,
                    key: examKey,
                })
            ),
        ]
    }, [])

    const tableData = useMemo((): {
        previousExamCode: string
        [PostSpring2023ExamCode.GHDP]: number
        [PostSpring2023ExamCode.GHVRUS]: number
        [PostSpring2023ExamCode.GHRM]: number
        [PostSpring2023ExamCode.REMOVED]: number
    }[] => {
        const data: {
            previousExamCode: string
            [PostSpring2023ExamCode.GHDP]: number
            [PostSpring2023ExamCode.GHVRUS]: number
            [PostSpring2023ExamCode.GHRM]: number
            [PostSpring2023ExamCode.REMOVED]: number
        }[] = []
        Object.values(PreSpring2023ExamCode).forEach((previousExamCode) => {
            const datum = {
                previousExamCode,
                [PostSpring2023ExamCode.GHDP]: 0,
                [PostSpring2023ExamCode.GHVRUS]: 0,
                [PostSpring2023ExamCode.GHRM]: 0,
                [PostSpring2023ExamCode.REMOVED]: 0,
            }
            Object.entries(PostSpring2023ExamCode).forEach(
                ([newExamCodeKey, newExamCodeValue]) => {
                    let numChapters = 0
                    props.includeSourceTypes.forEach((sourceType) => {
                        const hashKey = hashExamChangeAnalysisKey({
                            newExamCode: newExamCodeValue,
                            previousExamCode,
                            sourceType,
                        })
                        numChapters +=
                            CHAPTER_COUNT_BY_KEY_MAP.get(hashKey) || 0
                    })
                    datum[newExamCodeKey as PostSpring2023ExamCode] =
                        numChapters
                }
            )
            data.push(datum)
        })
        return data
    }, [props.includeSourceTypes])
    return (
        <div className={styles.examChangeTableContainer}>
            <Table
                dataSource={tableData}
                columns={columns}
                pagination={false}
            />
        </div>
    )
}
